import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { apiDashboardInfoToDashboardInfo, apiReportToReport, IMarkoutApiDependencySegment } from '@cbridge-packages/api-markout';
import { JobStatus } from '../markout.constant';
import { MarkoutAction } from '../markout.action';

type IDependencies = IMarkoutApiDependencySegment;

export const loadReportsEpic: IEpic<{}, IDependencies> = (action$, _, { moApi }) =>
  action$.pipe(
    isTypeOfAndGetPayload(MarkoutAction.loadReports.started),
    switchMap((params) => {
      const apiParams = {
        search: params.search,
        status: params.status as JobStatus | undefined,
        limit: params.limit,
        skip: params.skip,
      };
      return moApi.getReports(apiParams).pipe(
        mergeMap((response) => [
          MarkoutAction.loadReports.done({
            params,
            result: {
              reports: response.reports.map(apiReportToReport),
              dashboard: apiDashboardInfoToDashboardInfo(response.dashboard),
            },
          }),
        ]),
        catchApiError((error) => [
          MarkoutAction.loadReports.failed({ params, error }),
        ]),
      );
    }),
  );
